<template>
  <div>

    <CRow>
      <CCol md="12" class="mb-4">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>{{$t('VATReport')}}</strong>
              </CCol>

            </CRow>
            <CRow>
              <CCol col="3">
                <date-picker

                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>
              <CCol col="3">
                <CSelect
                    :label="$t('VATType')"
                    horizontal
                    :options="[{label:$t('SalesVat'),value:2},{label:$t('ExpensesVAT'),value:1}]"
                    :value.sync="selected_type"></CSelect>

              </CCol>
              <CCol col="1">
                <CButton @click="get_all_data" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>

            <CDataTableFixed
                :items="items_sell"
                :fields="selected_type==2 ? fields_sell : fields_buy"
                column-filter
                @row-clicked="table_row_clicked"
                height="350px"
                hover
                :export_excel_name="selected_type==2 ? 'Sales_Vat' : 'Expenses_VAT'"

                :export_excel="true"
                sorter
                border
                striped
                :sorter-value="{column:'id',asc:false}"
            >
              <template #row_id="{item,index}">

                <td >
                  <p style="text-align: center">{{ index + 1 }}</p>

                </td>

              </template>
              <template #docDate="{item}">
                <td>
                  <p style="text-align: center">{{ get_date(item.docDate) }}</p>
                </td>
              </template>
              <template #masterCode="{item}">
                <td>
                  <p style="text-align: center">{{ item.masterCode }}</p>
                </td>
              </template>
              <template #partyName="{item}">
                <td>
                  <p >{{ item.partyName }}</p>
                </td>
              </template>

              <template #factorAmount="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.factorAmount) }}</p>
                </td>
              </template>

              <template #vatAmount="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.vatAmount) }}</p>
                </td>
              </template>

              <template #totalSum="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.totalSum) }}</p>
                </td>
              </template>

              <template #caption>
                <tr class="total-table">

                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ $t('totalCirculation') }}</td>
                  <td>{{ get_currency(calculate_items(items_sell,'totalSum')) }}</td>

                  <td>{{ get_currency(calculate_items(items_sell,'vatAmount') )}}</td>
                  <td>{{ get_currency(calculate_items(items_sell,'factorAmount')) }}</td>

                </tr>

              </template>





            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      selected_type:2,
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',


      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,
      id_checkbox_items: [],
      item_sell_array: [],

      items_sell: [],
      table_clicks_timer:'',
      table_clicks:0,


      fields_sell: [
        {key: 'row_id', label: this.$t('tables.sharp'),sorter:false, _style: 'width:2%'},
        {key: 'masterCode', label: this.$t('factor_no'), _style: 'width:5%'},
        {key: 'partyName', label: this.$t('customerName'), _style: 'width:5%'},
        {key: 'docDate', label: this.$t('docDate') , _style: 'width:3%'},
        {key: 'totalSum', label: this.$t('NetAmount') , _style: 'width:3%'},
        {key: 'vatAmount', label: this.$t('VATAmount') , _style: 'width:3%'},

        {key: 'factorAmount', label: this.$t('totalSum'), _style: 'width:10%'},

      ],

      fields_buy: [
        {key: 'row_id', label: this.$t('tables.sharp'),sorter:false, _style: 'width:2%'},
        {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:5%'},
        {key: 'partyName', label: this.$t('supplierName'), _style: 'width:5%'},
        {key: 'docDate', label: this.$t('docDate') , _style: 'width:3%'},
        {key: 'totalSum', label: this.$t('NetAmount') , _style: 'width:3%'},
        {key: 'vatAmount', label: this.$t('VATAmount') , _style: 'width:3%'},

        {key: 'factorAmount', label: this.$t('totalSum'), _style: 'width:10%'},


      ],


      details: [],

      status_form: 0,

    }
  }, mounted() {

    this.start_date = this.get_day_before_today_in_day(5);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();


  }, watch: {

  },
  methods: {

    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.goShowDocument(item)
        this.table_clicks = 0

      }

    },
    get_all_data() {
      this.get_lists_sell();

    },

    get_lists_sell() {

      var self = this;


      const formData = new FormData();

      var url = "GetSalePurVATRpt";

      formData.append("Id", self.selected_type);
      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

        self.items_sell=[]

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          content_data.data.forEach(function (val){
            val.totalSum = val.factorAmount - val.vatAmount
          })
          self.items_sell = content_data.data

        } else {

          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },

  },

}

</script>
